import { Model } from '@/models/Model';
export class Media extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Media';
        this.$endpoint = '/media';
        this.$fillable = [];
    }
}
export var TargetType;
(function (TargetType) {
    TargetType["PROJECT"] = "project";
    TargetType["DOCUMENT"] = "student_document";
})(TargetType || (TargetType = {}));
export var MediaIncludes;
(function (MediaIncludes) {
    MediaIncludes["TARGET"] = "target";
    MediaIncludes["LINKS"] = "links";
})(MediaIncludes || (MediaIncludes = {}));
